module.exports = __webpack_public_path__ + "static/img/two-flex-img1.989d13a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowCode/two-flex-img1.png
// module id = EAzZ
// module chunks = 0